import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import SearchBar from '../components/studyroom/SearchBar';
import Pagination from '../components/pagination/Pagination';
import ExportModal from '../components/studyroom/ExportModal';
import StudyroomService from '../../service/studyroom/Studyroom';

export interface Form {
  idx: number;
  title: string;
}

function AuctionForm() {
  const [select, setSelect] = useState<Form | null>(null);
  const [openExportModal, setOpenExportModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [formList, setFormList] = useState<Form[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState('');
  const [input, setInput] = useState('');
  const limit = 10;

  const getList = async () => {
    try {
      console.log(search);
      const res = await StudyroomService.forms(currentPage, search);
      setFormList(res.data.list);
      setTotalCount(res.data.totalCount);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getList();
  }, [search, currentPage]);

  const handleSearch = (value: string) => {
    setCurrentPage(1);
    setSearch(value);
  };

  return (
    <Container>
      <SearchBox>
        <SearchBar onSearch={handleSearch} input={input} setInput={setInput} />
      </SearchBox>

      <Content>
        <Table>
          <thead>
            <tr>
              <Th>파일명</Th>
              <Th style={{ width: '130px' }}>파일 다운로드</Th>
            </tr>
          </thead>
          <tbody>
            {formList.map((file) => (
              <Tr>
                <Td>{file.title}</Td>
                <Td style={{ width: '130px' }}>
                  <Button
                    onClick={() => {
                      setSelect(file);
                      setOpenExportModal(true);
                    }}
                  >
                    <img
                      src="/assets/images/icon/download.svg"
                      alt="download"
                      width={16}
                      height={16}
                    />
                    다운로드
                  </Button>
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(totalCount / limit)}
          onPageChange={(page) => {
            setCurrentPage(page);
          }}
          removeMargin={true}
        />
      </Content>
      {openExportModal && select && (
        <ExportModal file={select} onClose={() => setOpenExportModal(false)} />
      )}
    </Container>
  );
}

export default AuctionForm;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`;

const SearchBox = styled.div`
  padding: 24px 16px;
`;

const Content = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #616161;
`;

const Th = styled.th`
  background-color: #f7f8fc;
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #e5e8ea;

  font-weight: 500;
  font-size: 13px;
  color: #616161;
`;

const Tr = styled.tr`
  border-bottom: 1px solid #e5e8ea;
`;

const Td = styled.td`
  padding: 10px 12px;
  font-weight: 500;
  font-size: 14px;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Button = styled.a`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  background-color: #70737c14;
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  padding: 12px 18px;
  border-radius: 8px;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
`;
